import React, { useEffect, useState } from "react";
import styles from "./sale.module.scss";
import { HorizontalFlex } from "../flex/HorizontalFlex";
import { VerticalFlex } from "../flex/VerticalFlex";
import {realPriceColor} from "../../utils/color"
import legacy from '../../utils/legacy';
import icons from "../../assets/images/icons";

// agent, more 은 true false 값으로 그리도록 처리
const getPhotoUrl = (photoUrl, type) => {

  if (!photoUrl) return null;
  const photos = photoUrl.split('|');

  let src = ""

  if (type == 'building'){
    src = "files/sale_photo/72x72_"
  }else if (type == 'agent'){
    src = "files/user_photo/100x100_"
  }

  for (let i = 0; i < photos.length; i++) {
    return legacy.server_by_hostname('aurora', src) + photos[i];
  }
  return null;
}

const EstateCard = ({
    onClick=() => {},
    image,
    title,
    dealType,
    price,
    tag,
    estateTypeTag,
    area,
    floor,
    timeAgo,
    more = false,
    maxPrice,
    minPrice,
    agentPhoto,
    agentName,
    agentOfficeName,
    agentPosition,
    agentTier,
    suid,
    creationDate,
    list = {
        id: 1,
        dealType: '매매',
        area: '대지 660㎡ 연 1,483㎡',
        floor: '3F / B1',
        price: '35억 5000만원',
        agent: {
          image: "https://via.placeholder.com/50",
          name: "지윤희",
          position: "대표",
          officeName: "요기조기 부동산",
        },
        image: 'https://via.placeholder.com/80x80'
    }
  }) => {
    
    function getTimeAgo(creationDate) {
      const now = new Date();
      const created = new Date(creationDate);

      const diffSec = Math.floor((now - created) / 1000);
    
      const units = [
        { label: '년', seconds: 60 * 60 * 24 * 365 },
        { label: '개월', seconds: 60 * 60 * 24 * 30 },
        { label: '주', seconds: 60 * 60 * 24 * 7 },
        { label: '일', seconds: 60 * 60 * 24 },
        { label: '시간', seconds: 60 * 60 },
        { label: '분', seconds: 60 },
      ];
    
      for (const unit of units) {
        const amount = Math.floor(diffSec / unit.seconds);
        if (amount > 0) return `${amount}${unit.label} 전`;
      }
    
      return '';
    }
    

    const [expanded, setExpanded] = useState(false);
    const maemulImage = getPhotoUrl(image,"building");
    const agentImage = getPhotoUrl(agentPhoto,"agent");
    useEffect(() => {
      setExpanded(false);
    }, [])
    return (
      <>
      <VerticalFlex className={styles.estateCard}>
        <div className={styles.estateContent} onClick={ more ? () => setExpanded(prev=>!prev) : () => onClick(suid)}>
          {/* 이미지 */}
          <img src={maemulImage} alt={title} className={styles.estateImage} />
  
          {/* 정보 */}
          <VerticalFlex className={styles.estateInfo}>
            <HorizontalFlex
              leftChildren={<span className={styles.estateTag} style={{...realPriceColor(estateTypeTag)}}>{tag}</span>}
              rightChildren={<p className={styles.estateTime}>{getTimeAgo(creationDate)}</p>}
            ></HorizontalFlex>
            <div className={styles.estateTitle}>{title}</div>
            <div>
              <span className={styles.dealType}>{dealType} </span>
              <span className={styles.estatePrice}>
                {more ? minPrice === maxPrice ? price : `${minPrice} ~ ${maxPrice}` : price}
              </span>
            </div>
            <div className={styles.estateDetails}>
              {floor ? `${area} | ${floor}` : area}
            </div>
          </VerticalFlex>
        </div>
  
        {/* 중복 매물 여부에 따른 UI 차이 */}
        {more ? (
          <>
            <div className={`${styles.estateDuplicates} ${styles.estateFooter} ${expanded ? styles.active : ''}`}
              onClick={() => setExpanded(prev => !prev)}>
              {expanded ? '간략히 보기' : `동일매물 ${list.length}개 확인`}
              <span>{expanded ? '▲' : '▼'}</span>
            </div>
            
          </>
        ) : (
          // 중복 매물이 없으면 중개사 정보 UI 표시
          
            <HorizontalFlex
              className={`${styles.estateAgent} ${styles.estateFooter}`}
              leftChildren={
                <img
                  src={agentImage}
                  alt={agentName}
                  className={styles.agentImage}
                />
              }
              leftParentClassName={styles.agentGap}
              rightChildren={
                <img className={styles.agentTier} src={icons.nameCard.pro} alt="pro tier" />
              }
              // rightChildren={agentTier === "pro" && (
              //   <img className={styles.agentTier} src={icons.nameCard.pro} alt="pro tier" />
              // )}
            >
              <HorizontalFlex
                className={styles.agentProfile}
                leftParentClassName={styles.agentProfileGap}
              >
                <div className={styles.agentName}>{agentName}</div>
                <div className={styles.agentPosition}>{agentPosition}</div>
              </HorizontalFlex>
  
              <div className={styles.agentAgency}>{agentOfficeName}</div>
            </HorizontalFlex>
          
        )}
      </VerticalFlex>
      {expanded && (
        <VerticalFlex className={styles.duplicateListWrapper} gap="12px">
        {list.map((item, idx) => (
          <VerticalFlex  key={`${item.suid}_${idx}`}  className={styles.duplicateEstateCard}>
            <div className={styles.duplicateItem} onClick={() => onClick(item.suid)}>
                {/* 이미지 */}
                <img src={getPhotoUrl(item.image, 'building')} alt="매물" className={styles.duplicateItemImage} />
                {/* 정보 */}
                <VerticalFlex className={styles.estateInfo}>
                  <div className={styles.estateTag} style={{...realPriceColor(item.estateTypeTag)}}>{item.tag}</div>
                  <div>
                    <span className={styles.dealType} style={{fontSize: "16px"}}>{item.dealType}</span>
                    <span className={styles.estatePrice} style={{fontSize: "16px"}}>{item.price}</span>
                  </div>
                  <div className={styles.estateDetails}>
                    {item.floor ? `${item.area} | ${item.floor}` : item.area}
                  </div>
                </VerticalFlex>
            </div>
            <div className={styles.duplicateStroke}></div>
            <HorizontalFlex
              className={styles.duplicateEstateAgent}
              leftChildren={
                <img
                  src={getPhotoUrl(item.agentPhoto,"agent")}
                  alt={item.agentName}
                  className={styles.agentImage}
                />
              }
              leftParentClassName={styles.agentGap}
              rightChildren={
                <img className={styles.agentTier} src={icons.nameCard.pro} alt="pro tier" />
              }
            >
              <HorizontalFlex
                className={styles.agentProfile}
                leftParentClassName={styles.agentProfileGap}
              >
                <div className={styles.agentName}>{item.agentName}</div>
                <div className={styles.agentPosition}>{item.agentPosition}</div>
              </HorizontalFlex>
  
              <div className={styles.agentAgency}>{item.agentOfficeName}</div>
            </HorizontalFlex>
          </VerticalFlex>
        ))}
      </VerticalFlex>
      )}
      </>
    );
  };


  export default EstateCard